





































import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';
import { Action, Getter } from 'vuex-class';
import AuthActionTypes from '@/modules/auth/AuthActionTypes';
import ListingService from '@/common/services/ListingService';
import ApplicationActionTypes from '@/modules/application/ApplicationActionTypes';
import DpButton from '@/components/atoms/DpButton/index.vue';
import { PlatformActionTypes } from '@/modules/platform/module';

@Component({
  name: 'MarketWidgetMapListingDetail',
  components: {
    SvgIcon,
    DpButton,
  },
})
export default class MarketWidgetMapListingDetail extends Vue {
  @Prop() protected listingDetail!: any;

  @Prop({ default: false }) protected locked!: boolean;

  @Getter('isAuthenticated', { namespace: 'auth' }) protected isAuthenticated!: boolean;

  @Action(ApplicationActionTypes.PUSH_ROUTE, { namespace: 'application' })
  protected dispatchPushRoute!: any;

  @Action(AuthActionTypes.SHOW_SIMPLE_AUTH_FORM, { namespace: 'auth' })
  protected dispatchShowSimpleAuthForm: any;

  @Action(PlatformActionTypes.CONNECT_AIRBNB_UNVERIFIED, { namespace: 'platform' })
  protected dispatchConnectAirbnbUnverified!: any;

  protected isAnalyzeListingFreeLoading: boolean = false;

  protected async toAnalyzeListingFree() {
    const listingUrl = ListingService.getPlatformLink(this.listingDetail);
    if (!listingUrl) {
      return;
    }
    if (this.isAuthenticated) {
      this.isAnalyzeListingFreeLoading = true;
      this.dispatchConnectAirbnbUnverified(listingUrl);
    } else {
      (window as any).location.href = `/app/en/airbnb-unverified-connect/${encodeURIComponent(listingUrl)}`;
    }
  }

  protected onClickUnlock() {
    this.dispatchShowSimpleAuthForm({ isViewAccountPerformance: false });
  }

  protected onClose() {
    this.$emit('onClose');
  }

  protected openListingOnPlatform = (listingDetail: any) => {
    const link = ListingService.getPlatformLink(listingDetail);
    if (link) {
      window.open(link, '_blank');
    }
  };
}
